import moment from 'moment'

function formatDateRange(range) {
  let queryStr = ''
  if (range && range.length === 2) {
    range = range.forEach((item, index) => {
      const date = moment(item).format('YYYY-MM-DD HH:mm:ss')
      queryStr += index === 0 ? '>=' + date :  '<=' + date
    })
  }
  return queryStr
}

const queryHelper = {
  formatDateRange,
}

export default {

  install(Vue) {
    Vue.prototype.$queryHelper = queryHelper
  }

}
